export interface BusinessType {
  code: string;
  displayText: string;
}

/**
 * Canonical copy of core-systems' `BankStatementAnalysisBusinessType` SmartEnum
 * (dhmtg/core-systems, src/api/Deephaven.Core/BankStatementAnalysis/Entities/
 * BankStatementAnalysisBusinessType.cs).
 *
 * `code` is sent on the wire as `businessType` and is validated/stored
 * server-side, so it MUST stay character-for-character in sync with the
 * SmartEnum values. "Other" must remain last — selecting it reveals the
 * free-text `businessTypeOther` field.
 */
export const BUSINESS_TYPES: BusinessType[] = [
  { code: 'ConstructionAndTrades', displayText: 'Construction and Trades' },
  { code: 'TransportationAndDelivery', displayText: 'Transportation and Delivery' },
  { code: 'Automotive', displayText: 'Automotive' },
  { code: 'FoodAndRetail', displayText: 'Food and Retail' },
  { code: 'PersonalServices', displayText: 'Personal Services' },
  { code: 'HealthcareChildcareAndEducation', displayText: 'Healthcare, Childcare and Education' },
  { code: 'RealEstate', displayText: 'Real Estate' },
  { code: 'FinanceAndInsurance', displayText: 'Finance and Insurance' },
  { code: 'ProfessionalServices', displayText: 'Professional Services' },
  { code: 'Technology', displayText: 'Technology' },
  { code: 'Other', displayText: 'Other' },
];

/** The `businessType` code whose selection requires `businessTypeOther`. */
export const BUSINESS_TYPE_OTHER_CODE = 'Other';
